// @module PDPSchema.Product.Model
define('PDPSchema.Product.Model',
[
    'Product.Model'
],
function (
	ProductModel
){
	'use strict';

	// @class PDPSchema.Product.Model custom properties and methods added to Product.Model
	_.extend(ProductModel.prototype, {

        // @method buildItemSeoDescription
        // Filters out quote and aposthrophe characters
        // text description.
        // @param {String} textDescription
        // @return {String}
        buildItemSeoDescription: function (textDescription) {
            var description = textDescription || '';

            // Filter out apostrophes and quotes
            description = description.replace(/['"]/g, '');

            return description;
        },

        // @method isMatrixItem
        // Returns true if item model is a matrix item.
        // @return {Boolean}
        isMatrixItem: function () {
            return this.get('item').containsMatrixChildItems();
        }

    });

});
